import {
  AD_ACCOUNT,
  AD_GROUP,
  CAMPAIGN,
  CREATIVE,
  KEYWORD,
} from 'features/report/common/DomainText'
import { partialClone } from 'utils'
import { clone } from 'lodash'

const base = [
  'domainStatuses',
  'metricsTypes',
  'analysisItem',
  'analysisPeriod',
  'period',
]
export const protocol = {
  [AD_ACCOUNT]: base,
  [CAMPAIGN]: base,
  [AD_GROUP]: [...base, 'campaignId'],
  [CREATIVE]: [...base, 'campaignId', 'adGroupId'],
  [KEYWORD]: [...base, 'campaignId', 'adGroupId'],
}

export const sanitize = formValues => {
  const reqBody = partialClone(formValues, protocol[formValues.domain])
  const period = clone(reqBody.period)
  reqBody.period.relative ? (period.specific = null) : (period.relative = null)
  reqBody.period = period
  return reqBody
}
